import { render } from "./TnvedNonEnergy.vue?vue&type=template&id=08927010&scoped=true"
import script from "./TnvedNonEnergy.vue?vue&type=script&lang=js"
export * from "./TnvedNonEnergy.vue?vue&type=script&lang=js"

import "./TnvedNonEnergy.vue?vue&type=style&index=0&id=08927010&lang=scss&scoped=true"
import "./TnvedNonEnergy.vue?vue&type=style&index=1&id=08927010&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08927010"]])

export default __exports__